<template>
    <h1>Vista de Listagem de Auto-avaliações</h1>
    <AssessmentQuestionaireManagementTable 
        :assessment-type="'self'"
    />
</template>
<script setup>
import AssessmentQuestionaireManagementTable from '@/components/assessments/questionaires/AssessmentQuestionaireManagementTable.vue';


</script>